import { CircularProgress } from "@mui/material";
import { Buffer } from "buffer";
import { useEffect } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import useAuth from "../../contexts/AuthContext";
import { useMaybeUserContext } from "../../contexts/UserContext";
import AuthAPI from "../../lib/auth";
import UserAPI from "../../lib/user";
import { useOnBehalfOfValue, useSetOnBehalfOf } from "../../recoil/admin/hooks";

function LoginOnBehalfOf() {
	const auth = useAuth();
	const navigate = useNavigate();
	const params = useParams<{
		token: string;
	}>();

	const setOnBehalfOf = useSetOnBehalfOf();
	const onBehalfOf = useOnBehalfOfValue();
	const userContext = useMaybeUserContext();

	if (!params.token) {
		return <Navigate to="/login" />;
	}

	useEffect(() => {
		if (!auth.isAuthenticated) return;

		const hasChangedToUser = onBehalfOf?.phoneNumber && onBehalfOf?.phoneNumber === userContext?.user?.phone;
		if (!hasChangedToUser) return;

		navigate("/accounts", { replace: true });
	}, [auth.isAuthenticated, onBehalfOf, userContext]);

	useEffect(() => {
		// validate if token is valid
		async function performLoginOnBehalfOf() {
			if (!params.token) return;

			// parse params.token from base64
			const token = Buffer.from(params.token, "base64").toString("ascii");
			const authAPI = new AuthAPI(token);

			const isValid = await authAPI.validateToken();

			if (!isValid) {
				console.log("Invalid token", token);
				return;
			}

			auth.loginWithToken(token);

			const user = await new UserAPI(token).getUser();
			setOnBehalfOf({
				firstname: user.firstName ?? "",
				lastname: user.lastName ?? "",
				phoneNumber: user.phoneNumber ?? "",
			});
		}

		performLoginOnBehalfOf();
	}, [params.token, setOnBehalfOf]);

	return <CircularProgress />;
}

export default LoginOnBehalfOf;
